import React, { useState } from 'react';
import ApiService from '../api_services/apiService';
import './Modals.css';


import { ReactComponent as Settings } from '../icons/settings.svg';
import { ReactComponent as EyeSlash } from '../icons/eye-slash.svg';
import { ReactComponent as Eye } from '../icons/eye.svg';

const SettingsModal = ({ onClose }) => {
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [repeatNewPassword, setRepeatNewPassword] = useState('');

    const [showOldPassword, setShowOldPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showRepeatPassword, setShowRepeatPassword] = useState(false);

    const handleSave = async () => {
        if (newPassword !== repeatNewPassword) {
            alert('Nowe hasło i powtórzone hasło muszą być identyczne.');
            return;
        }

        try {
            const response = await ApiService.changePasswordWithOld(oldPassword, newPassword);

            // Sprawdzenie czy w odpowiedzi występuje ciąg "ERROR" lub pole status z błędem
            const isError = (typeof response === 'string' && response.includes('ERROR')) || 
                            (response && response.status === 'ERROR');

            if (isError) {
                // Jeśli odpowiedź zawiera błąd, wyświetlamy komunikat (response może być stringiem lub obiektem)
                const message = typeof response === 'object' && response.message ? response.message : 'Wystąpił błąd podczas zmiany hasła.';
                alert(`Błąd: ${message}`);
            } else {
                alert('Hasło zostało pomyślnie zmienione.');
                onClose();
            }
        } catch (error) {
            // Błędy sieciowe lub statusy 4xx/5xx są zazwyczaj obsługiwane przez interceptor ApiService,
            // ale na wszelki wypadek logujemy je tutaj.
            console.error(error);
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content settings-modal">
                <div className="modal-header">
                    <h3><Settings></Settings> Ustawienia profilu</h3>
                    <button className="close-btn" onClick={onClose}>&times;</button>
                </div>
                <div className="modal-body">
                    <div className="input-group">
                        <label>Stare hasło</label>
                        <div className="password-wrapper">
                            <input
                                className="password"
                                type={showOldPassword ? "text" : "password"} 
                                placeholder="************" 
                                value={oldPassword}
                                onChange={(e) => setOldPassword(e.target.value)}
                            />
                            <span 
                                className="eye-icon" 
                                onClick={() => setShowOldPassword(!showOldPassword)}
                            >
                                {showOldPassword ? <EyeSlash></EyeSlash> : <Eye></Eye>}
                            </span>
                        </div>
                    </div>
                    <div className="input-group">
                        <label>Nowe hasło</label>
                        <div className="password-wrapper">
                            <input
                                className="password"
                                type={showNewPassword ? "text" : "password"} 
                                placeholder="************" 
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                            />
                            <span 
                                className="eye-icon" 
                                onClick={() => setShowNewPassword(!showNewPassword)}
                            >
                                {showNewPassword ? <EyeSlash></EyeSlash> : <Eye></Eye>}
                            </span>
                        </div>
                    </div>
                    <div className="input-group">
                        <label>Powtórz nowe hasło</label>
                        <div className="password-wrapper">
                            <input
                                className="password"
                                type={showRepeatPassword ? "text" : "password"}
                                placeholder="************" 
                                value={repeatNewPassword}
                                onChange={(e) => setRepeatNewPassword(e.target.value)}
                            />
                            <span 
                                className="eye-icon" 
                                onClick={() => setShowRepeatPassword(!showRepeatPassword)}
                            >
                                {showRepeatPassword ? <EyeSlash></EyeSlash> : <Eye></Eye>}
                            </span>
                        </div>
                    </div>

                    <div className="modal-footer">
                        <button className="btn-cancel" onClick={onClose}>Anuluj</button>
                        <button className="btn-save" onClick={handleSave}>Zapisz zmiany</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SettingsModal;